// Copyright (c) 2016 Deere & Company

import MaintenancePlanInfoContainer from './maintenance-plan-info-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.maintenancePlan.claim,
    formValidation: state.claims.maintenancePlan.formValidation,
    isEditable: state.claims.maintenancePlan.isEditable,
    openMaintenancePlans: state.claims.maintenancePlan.openMaintenancePlans,
    openServiceIntervals: state.claims.maintenancePlan.openServiceIntervals,
    selectedOpenMaintenancePlan: state.claims.maintenancePlan.selectedOpenMaintenancePlan
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(MaintenancePlanInfoContainer);



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/components/maintenance-plan-info/index.js